import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import {convertStringToElements }from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { submitAuthAgent } from "./AssignAgentForm/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import RectangleLoader from "common-components/RectangleLoader";
import Container from "common-components/Container";
import Button from "common-components/Buttons";
import Alert from "common-components/Alert";
import { AssignAgentForm } from "./AssignAgentForm";

class AuthorizedAgentReview extends Component {
  state = {
    showForm: false
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("authorized agent review", this.props.pageContent.sc_pagetitle);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showForm !== prevState.showForm && this.state.showForm === false) {
      const element = document.getElementById("review_auth_agent_info");

      if (element) {
        const offset = 125;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }

  submitAuthAgent = () => {
    this.props.submitAuthAgent().then(() => {
      if (!this.props.error) {
        this.props.history.push("/privacy/secure/your-data/authorized-agent/submit-success", {
          confirmAuth: true
        });
      }
    });
  };

  render() {
    if (!this.props.formContent || !checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/your-data/authorized-agent/information" />;
    }

    const { formContent, nameLabel, addressLabel, phoneLabel } = this.props;
    const { section_title, section_description, buttons } = this.props.pageContent;

    if (this.props.loading) {
      return <RectangleLoader id="formerLoader"/>;
    }

    return (
      <Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <Header>{section_title}</Header>
        <p style={{ margin: "40px 0", maxWidth: "595px" }}>{convertStringToElements(section_description)}</p>
        {!this.state.showForm ? (
          <Fragment>
            <Div id="review_auth_agent_info">
              <EditButton onClick={() => this.setState({ showForm: true })}>Edit</EditButton>
              <div style={{ marginBottom: "24px" }}>
                <H2>{nameLabel}</H2>
                <p>{formContent.values.entity_name}</p>
                <p>{formContent.values.entity_email}</p>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <H2>{addressLabel}</H2>
                <p>{formContent.values.street_address}</p>
                {formContent.values.secondary_address ? <p>{formContent.values.secondary_address}</p> : null}
                <p>
                  {formContent.values.city}, {formContent.values.state}
                </p>
                <p>{formContent.values.zip_code}</p>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <H2>{phoneLabel}</H2>
                <p data-qm-encrypt="true" >{formContent.values.phone_number}</p>
              </div>
            </Div>
            <Button onClick={this.submitAuthAgent} style={{ marginTop: "56px" }} background={buttons[0].type}>
              {buttons[0].text}
            </Button>
          </Fragment>
        ) : (
          <AssignAgentForm inEditMode onSubmit={() => this.setState({ showForm: false })} />
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: {
    assign_agent_review: pageContent,
    assign_agent_form: { genericList: [{ text: nameLabel }, { text: addressLabel }, { text: phoneLabel }] } = {
      genericList: [{ text: "" }, { text: "" }]
    }
  },
  form: { authAgentInfo: formContent },
  loadingAndErrorState: { loading, error }
}) => ({
  pageContent,
  formContent,
  nameLabel,
  addressLabel,
  phoneLabel,
  loading,
  error
});

export default connect(
  mapStateToProps,
  { setA11yContent, submitAuthAgent }
)(AuthorizedAgentReview);

const H2 = styled.h2`
  font-size: 14px;
  line-height: 14.5px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-weight: 700;
  margin-bottom: 13px;
`;

const Div = styled.div`
  padding-top: 4px;
  max-width: 385px;
  border-top: 4px solid #000;
  border-bottom: 1px solid #000;
`;

const EditButton = styled.button`
  float: right;
  cursor: pointer;
  background: 0;
  border: 0;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  color: #747676;
  padding: 0;
  border-bottom: 1px solid #747676;
`;
